(ns teamoesterreich.admin-mode.lebensretter.lr-user.modal.document-select-modal
  (:require [reagent-material-ui.components :as mui]
            [reagent-material-ui.icons.delete-forever :refer [delete-forever]]
            [reagent-material-ui.icons.keyboard-arrow-left :refer [keyboard-arrow-left]]
            [reagent.core :as r]
            [teamoesterreich.setup :refer [USER_DOCUMENT_TYPES]]
            [teamoesterreich.admin-mode.data.backend :as backend]
            [teamoesterreich.ajax :as ajax]
            [teamoesterreich.element.backend-file :as backend-file]
            [teamoesterreich.util.date :as h-date]))



(defn date-conv [date]
  ;20180701T100000.000Z -> 2021-06-20T23:24
  (if (> (count date) 12)
    (str (subs date 0 4) "-" (subs date 4 6) "-" (subs date 6 8)
         )
    ""
    )
  )


(defn >user-edit-document-field [document-uuid obj cb-fn]
  (ajax/patch> (str backend/BASE_URL "/user/document/" document-uuid)
               (ajax/serialize (merge {:userDocument-uuid document-uuid}
                                      obj))
               cb-fn))





(defn no-document-block [onSelect-cb]
  [:div {:class "clickable" :onClick #(onSelect-cb {:userDocument-uuid nil})
         :style {:padding "5px 0 0 5px" :margin "0 5px 0 5px" :height "110px" :borderBottom "2px dotted black"}}

   [delete-forever
    {:style {:position "relative" :float "right" :maxHeight "100px" :maxWidth "180px" :object-fit "contain"}}]

   [:div {:style {:width "calc(100% - 202px)"}} "Kein Dokument zuweisen"]

   [:br]
   ]

  )

(defn document-block [{:keys [userDocument-type userDocument-fileName userDocument-path userDocument-since userDocument-validTo] :as document} onSelect-cb]
  [:div {:class "clickable" :onClick #(onSelect-cb document)
         :style {:padding "5px 0 0 5px" :margin "0 5px 0 5px" :height "110px" :borderBottom "2px dotted black"}}

   [backend-file/img {:hash             userDocument-path
                             :preview? true
                             :style    {:position "relative" :float "right" :maxHeight "100px" :maxWidth "180px" :object-fit "contain"} :alt "Ansicht"}]

   [:div {:style {:width "calc(100% - 202px)"}}
    [:span {:style {:fontWeight "bold"}} (or userDocument-fileName userDocument-path)]
    [:br]
    [:span {:gutterBottom true :style {}} (or (get USER_DOCUMENT_TYPES userDocument-type) (str "Sonstiges " userDocument-type))]
    [:br]
    (when userDocument-since [:span {} "Hochgeladen: " (h-date/print-local-date userDocument-since)])
    [:br]
    (when userDocument-validTo
      [:span {:style {:color (if (h-date/date>? (h-date/parse-service-date! userDocument-validTo) (h-date/now)) "red" "inherit")}}
       "Gültig bis: " (h-date/print-local-date userDocument-validTo)])
    ]
   [:br]
   ]

  )


(defn modal [!actual-user !show title onSelect-cb]
  [mui/modal
   {:className        "doc-select-load-modal"

    :aria-labelledby  "simple-modal-title"
    :aria-describedby "simple-modal-description"
    :style            {:display        "flex"
                       :marginRight    "auto"
                       :marginLeft     "auto"
                       :alignItems     "center"
                       :justifyContent "center"}
    :open             (or @!show false)

    }
   (when @!show
     [:div
      {
       :class "modal"
       :style {:width 720 :height "60%" :padding "0 5px 0 5px"}}
      [:h2 title]
      [:div {:style {
                     :maxHeight  "calc(100% - 152px)"
                     :overflow-y "scroll"
                     }}
       [no-document-block onSelect-cb]
       (doall (for [document (reverse (sort :userDocument-since (filter :userDocument-active (:user-userDocument @!actual-user))))]
                (do
                  ^{:key (str "userDocument-" (:userDocument-uuid document))}
                  [document-block document onSelect-cb]
                  )))
       ]
      [mui/button
       {:variant   "contained"
        :startIcon (r/as-element [keyboard-arrow-left])
        :style     {:margin "5px 0 0 50px"}
        :onClick   #(reset! !show false)
        }
       "Abbrechen"]

      ])])

